<template>
    <jet-dialog-modal ref="modal" :show="show_modal" maxWidth="lg" @close="show_modal = false">
        <template v-slot:title>
            <div class="flex text-gray-700">
                <span>Enable GDPR Opt-in</span>
                <!-- <vue-feather type="link-2" class="h-5 w-5 ml-2 self-center"></vue-feather> -->
            </div>
        </template>
        <template v-slot:content>

            <div class="text-gray-600">
                You must add your Privacy Policy page URL 
            </div>

            <div class="text-gray-600 grid grid-cols-6 gap-4">
                
                <div class="col-span-6 flex flex-col justify-center pr-6">
                   <jet-input id="url"
                        type="url"
                        ref="url"
                        class="mt-1 mr-6 block w-full"
                        v-model="url"
                        placeholder="https://" />
                </div>

            </div>
        </template>
        <template v-slot:footer>
            <div class="flex w-full flex-row justify-between">
                <div class="flex w-full">
                    <jet-button
                        class="w-full place-content-center"
                        :disabled="!urlValid"
                        @click="save">
                        Enable Gdpr
                    </jet-button>
                </div>
            </div>
        </template>
    </jet-dialog-modal>
</template>

<script>

import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'

export default {

    props: [''],

    components: {
        JetDialogModal, JetButton, JetInput, JetLabel
    },

    data() {
        return {
            show_modal: false,
            url: null,
        }
    },

    created: function() {
        
    },

    emits: ["callback"],

    methods: {
        open: function() {
           this.show_modal = true
           setTimeout(function(){
               this.$refs.url.focus()
           }.bind(this), 300)
        },
        close: function() {
            this.$emit('callback', { url: null })
            this.show_modal = false
        },
        save: function() {
            if (this.validateUrl(this.url)) {
                this.$emit('callback', { url: this.url })
            }  
            this.show_modal = false
        },
        validateUrl: function(value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validateNotempty: function(value) {
            var re = /^\s*\S+.*/;
            return re.test(value);
        }
    },

    watch: {
        url(value){
          this.url = value;
          this.urlValid = this.validateUrl(value) && this.validateNotempty(value)
        }
    },

}

</script>


